import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../../../IconLabel';

import classNames from 'classnames';
import classes from '../InlineTools.module.scss';
import './Code.module.scss';

interface CodeProps {
  editor: Editor;
}

export const Code: FunctionComponent<CodeProps> = ({ editor }) => {
  const { t } = useTranslation();

  const { isActive, canToggle } = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isActive: editor.isActive('code'),
      canToggle: editor.can().chain().focus().toggleCode().run(),
    }),
  });

  return (
    <IconLabel
      iconId={'code'}
      iconSize={16}
      ariaLabel={t('richTextEditor.tool-names-inline-code')}
      onClick={() => editor.chain().focus().toggleCode().run()}
      disabled={!canToggle}
      className={classNames(classes['inline-tools__item'], {
        [classes['inline-tools__item--active']]: isActive,
        [classes['inline-tools__item--disabled']]: !canToggle,
      })}
    />
  );
};
